import React, { useEffect, useState } from 'react'
import { getAvatarURL } from 'pages/main/data/avatarService'
import { getInitialAvatarSrc } from 'utils/ui'

interface AvatarProps {
  name: string
  email: string
  skipLogo?: boolean
}

const Avatar: React.FC<AvatarProps> = ({ name, email, skipLogo = false }) => {
  const [avatarUrl, setAvatarUrl] = useState<string>(getInitialAvatarSrc(name, email))

  useEffect(() => {
    const loadAvatar = async () => {
      try {
        const avatarUrl = await getAvatarURL(name, email, skipLogo)
        if (avatarUrl) {
          setAvatarUrl(avatarUrl)
          return
        }
      } catch (error) {
        console.error('Avatar loading error:', error)
      }
    }

    loadAvatar()
  }, [email, name, skipLogo])

  return <img src={avatarUrl} alt="Attendee" />
}

export default Avatar
